import { render, staticRenderFns } from "./login-tpl.vue?vue&type=template&id=aa2cf114&scoped=true"
import script from "./login-tpl.vue?vue&type=script&lang=js"
export * from "./login-tpl.vue?vue&type=script&lang=js"
import style0 from "./login-tpl.vue?vue&type=style&index=0&id=aa2cf114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2cf114",
  null
  
)

export default component.exports